import { EmptyState } from '@app/components/base/EmptyState';
import RuleOutlinedIcon from '@mui/icons-material/RuleOutlined';
import { defineMessage, FormattedMessage } from 'react-intl';

const noMatchesReportEmptyHelp = defineMessage({
  id: 'audit.noMatchesReport.emptyState.help',
  defaultMessage:
    'Muestra los archivos de media cargados en el intervalo seleccionado para los que no se detectó ningún match en ese intervalo o en el otro intervalo ajustado.',
});

/**
 * Placeholder shown before the first no-matches report run, explaining what the report calculates.
 */
export function NoMatchesReportEmptyState() {
  return (
    <EmptyState
      icon={RuleOutlinedIcon}
      message={false}
      help={<FormattedMessage {...noMatchesReportEmptyHelp} />}
    />
  );
}
